import { render, staticRenderFns } from "./PercentageAvailability.vue?vue&type=template&id=55bcb974"
import script from "./PercentageAvailability.vue?vue&type=script&lang=js"
export * from "./PercentageAvailability.vue?vue&type=script&lang=js"
import style0 from "./PercentageAvailability.vue?vue&type=style&index=0&id=55bcb974&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports